import produce from 'immer';

import * as actionTypes from './actionTypes';

const defaultState = {
  user: null,
  isAdmin: false,
  permissions: [],
};

const authReducer = produce((draft, { type, payload }) => {
  const newState = draft;
  switch (type) {
    case actionTypes.GET_LOGIN_URL_SUCCESS:
      window.location = payload;
      break;
    case actionTypes.GET_LOGOUT_URL_SUCCESS:
      localStorage.removeItem('OSS_Token');
      localStorage.removeItem('OSS_Token_EXPIRES_ON');
      window.location = payload;
      break;
    case actionTypes.GET_TOKEN_DATA_SUCCESS:
      if (payload.token) {
        localStorage.setItem('OSS_Token', payload.token);
        localStorage.setItem('OSS_Token_EXPIRES_ON', payload.expiresOn);
        localStorage.setItem('OSS_Must_Login_Oss', true);
      } else {
        console.log(payload.error);
      }
      break;
    case actionTypes.LOAD_USER_SUCCESS:
      newState.user = payload.user;
      break;
    case actionTypes.LOAD_PERMISSIONS_SUCCESS:
      newState.isAdmin = payload.isAdmin;
      newState.permissions = payload.permissions || [];
      break;
    case actionTypes.CHECK_TOKEN_SUCCESS:
      localStorage.setItem('OSS_Token_EXPIRES_ON', payload.expiresOn);
      break;
    case actionTypes.REMOVE_PERMISSIONS:
      newState.isAdmin = false;
      newState.permissions = [];
      break;
    default:
  }
}, defaultState);

export default authReducer;
